// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsWrapper":"BlogBreadcrumbs_breadcrumbsWrapper__6lzn3"};